<script>
import { ref } from 'vue'
import html2pdf from "html2pdf.js";
import DeviceTemp from "../device/device-temp";
export default {
  components: {
    DeviceTemp
  },
  props: ['data'],
  created() {
    /*setTimeout(()=>{
      this.exportToPDF()
    }, 10 * 1000)*/
  },
  computed: {
  },
  data() {
    return {
      sendTime: "",
      dataStatus: false,
      weatherNow: null,
      deviceData: null,
      tempData: [],
      ticketData: null,
      deviceTypes: {
        1: "REFRIGERATEUR",
        2: "CONGELATEUR",
        3: "ARMOIRES_FRIGORIFIQUE",
        4: "CHAMBRE_FROIDE",
        5: "CAMION",
        6: "SUPER_CONGELATEUR",
      },
      tab: ref('null')
    };
  },
  watch: {
    data(newVal) {
      this.ticketData = newVal.ticket
      this.deviceData = newVal.deviceData
      this.tempData = newVal.tempData
      this.dataStatus = true
      
    }
  },
  methods: {
    handleModalShown(){
      this.dataStatus = false
    },
    exportToPDF() {
      const data = Object.assign({}, this.$refs);
      data.hide.removeAttribute("hidden");
      html2pdf(document.getElementById("export-pdf"), {
        margin: 0,
        filename: "generated-pdf.pdf",
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: { scale: 1 },
        jsPDF: { unit: 'pt', format: 'a4', floatPrecision: 'smart', orientation: 'l' }
      });
      data.hide.setAttribute("hidden", "hidden");
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      id="ticket-infos-modal"
      ref="ticket-infos-modal"
      size="xl"
      :title="$t('modals.ticket.text')"
      @shown="handleModalShown"
      hide-footer
    >
      <div>
        <div
          v-if="!dataStatus"
          class="loaderDiv d-flex justify-content-center align-items-center"
          style="min-height: 500px"
        >
          <b-spinner
            label="Loading..."
            variant="primary"
            style="width: 3rem; height: 3rem"
          ></b-spinner>
        </div>
        <div v-if="dataStatus" class="row">
          <div class="col-12 text-center font-weight-bold" style="color: black">
            <p >{{deviceData?.name}}</p>
          </div>
        </div>
        <div v-if="dataStatus" class="row">
          <div class="col-12" >
            <div style="display: flex; flex-direction: row; justify-content: end">
              <img
                  src="@/assets/images/temperature.svg"
                  style="width: 27px; height: auto"
                />
              <div class="text-truncate" style="font-size: 0.8rem; color:black">
                <b>{{$t("modals.temperature.text")}} : </b> <span style="color: purple">{{ ticketData.temp }} °C</span><br />
              </div>
              <img
                  src="@/assets/images/weather.svg"
                  style="width: 27px; height: auto; margin-left: 3%"
                />
              <div class="text-truncate" style="font-size: 0.8rem; color:black">
                <b>{{$t("modals.weather.text")}} :</b> <span style="color: purple">{{ ticketData.meteo }} °C</span><br />
              </div>
              <b-button @click="exportToPDF()">
                export
              </b-button>
            </div>
          </div>
        </div>
        <div v-if="dataStatus" class="row">
          <div class="col-12 col-lg-6">
            <div class="row">
              <div class="col-12 p-0 flex-container-img">
                <img
                  src="@/assets/images/ticket.svg"
                  style="width: 40%; height: auto"
                />
              </div>
              <div class="col-12 text-center">
                <div style="font-size: 1rem; color:black"><b>{{ticketData?.technicien || '-'}}</b></div>
                <p class="badge badge-secondary font-size-14">technicien</p>
              </div>
              
            </div>
          </div>
          <div class="col-12 col-lg-6" style="color: black">
            <v-app>
              <v-tabs
                v-model="tab"
                align-tabs="center"
                color="error"
              >
                <v-tab href="#equip">Equipement</v-tab>
                <v-tab-item value="equip">
                  <div class="row mt-1">
                    <div class="col-3 font-weight-bold">
                      Serial
                    </div>
                    <div class="col-9 text-secondary">
                      {{deviceData?.serial}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      Region
                    </div>
                    <div class="col-9 text-secondary">
                      {{deviceData?.region.name || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      Province
                    </div>
                    <div class="col-9 text-secondary">
                      {{deviceData?.province.name || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      Type
                    </div>
                    <div class="col-9 text-secondary">
                      {{deviceTypes[deviceData?.type] || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      {{$t("modals.vaccinTypes.text")}}
                    </div>
                    <div class="col-9 text-secondary">
                      {{deviceData?.vaccinTypes?.map(obj => obj.name)?.join(',') || '-'}}
                    </div>
                  </div>
                </v-tab-item>
                <v-tab href="#details">Détails</v-tab>
                <v-tab-item value="details">
                  <div class="row mt-1">
                    <div class="col-3 font-weight-bold">
                      Actions
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.actions || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      Causes
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.causes || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      {{$t("modals.createdAt.text")}}
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.date}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      {{$t("modals.closedAt.text")}}
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.closedAt || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      {{$t("modals.createdBy.text")}}
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.createdBy || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      {{$t("modals.closedBy.text")}}
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.closedBy || '-'}}
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs>
            </v-app>
          </div>
        </div>
        <div v-if="dataStatus" class="row">
          <div class="col-12">
            <DeviceTemp
              v-bind:events="tempData"
              :device="deviceData"
              :rangeTime="sendTime"
              :loader="false"
            />
          </div>
        </div>
      </div>
      <div id="export-pdf" ref="hide" hidden>
        <div v-if="dataStatus" class="row">
          <div class="col-12 text-center font-weight-bold" style="color: black">
            <p >{{deviceData?.name}}</p>
          </div>
        </div>
        <div v-if="dataStatus" class="row">
          <div class="col-12" >
            <div style="display: flex; flex-direction: row; justify-content: end">
              <img
                  src="@/assets/images/temperature.svg"
                  style="width: 27px; height: auto"
                />
              <div class="text-truncate" style="font-size: 0.8rem; color:black">
                <b>{{$t("modals.temperature.text")}} : </b> <span style="color: purple">{{ ticketData.temp }} °C</span><br />
              </div>
              <img
                  src="@/assets/images/weather.svg"
                  style="width: 27px; height: auto; margin-left: 3%"
                />
              <div class="text-truncate" style="font-size: 0.8rem; color:black">
                <b>{{$t("modals.weather.text")}} :</b> <span style="color: purple">{{ ticketData.meteo }} °C</span><br />
              </div>
              <b-button @click="exportToPDF()">
                export
              </b-button>
            </div>
          </div>
        </div>
        <div v-if="dataStatus" class="row">
          <div class="col-12 col-lg-6" style="color: black">
            <div class="row">
              <v-app>
                <v-tabs
                  v-model="tab"
                  align-tabs="center"
                  color="error"
                >
                  <v-tab href="#equip">Equipement</v-tab>
                  <v-tab-item value="equip">
                    <div class="row mt-1">
                      <div class="col-3 font-weight-bold">
                        Serial
                      </div>
                      <div class="col-9 text-secondary">
                        {{deviceData?.serial}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 font-weight-bold">
                        Region
                      </div>
                      <div class="col-9 text-secondary">
                        {{deviceData?.region.name || '-'}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 font-weight-bold">
                        Province
                      </div>
                      <div class="col-9 text-secondary">
                        {{deviceData?.province.name || '-'}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 font-weight-bold">
                        Type
                      </div>
                      <div class="col-9 text-secondary">
                        {{deviceTypes[deviceData?.type] || '-'}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 font-weight-bold">
                        {{$t("modals.vaccinTypes.text")}}
                      </div>
                      <div class="col-9 text-secondary">
                        {{deviceData?.vaccinTypes?.map(obj => obj.name)?.join(',') || '-'}}
                      </div>
                    </div>
                  </v-tab-item>
                </v-tabs>
              </v-app>
              <div class="col-12 text-center">
                <div style="font-size: 1rem; color:black"><b>{{ticketData?.technicien || '-'}}</b></div>
                <p class="badge badge-secondary font-size-14">technicien</p>
              </div>
              
            </div>
          </div>
          <div class="col-12 col-lg-6" style="color: black">
            <v-app>
              <v-tabs
                v-model="tab"
                align-tabs="center"
                color="error"
              >
                <v-tab href="#details">Détails</v-tab>
                <v-tab-item value="details">
                  <div class="row mt-1">
                    <div class="col-3 font-weight-bold">
                      Actions
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.actions || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      Causes
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.causes || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      {{$t("modals.createdAt.text")}}
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.date}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      {{$t("modals.closedAt.text")}}
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.closedAt || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      {{$t("modals.createdBy.text")}}
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.createdBy || '-'}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 font-weight-bold">
                      {{$t("modals.closedBy.text")}}
                    </div>
                    <div class="col-9 text-secondary">
                      {{ticketData?.closedBy || '-'}}
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs>
            </v-app>
          </div>
        </div>
        <!-- <div v-if="dataStatus" class="row">
          <div class="col-12">
            <DeviceTemp
              v-bind:events="tempData"
              :device="deviceData"
              :rangeTime="sendTime"
              :loader="false"
            />
          </div>
        </div> -->
      </div>
    </b-modal>
  </div>
</template>
<style>
.flex-container-img {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
</style>
<style scoped lang="scss">
 ::v-deep .v-application--wrap {
    min-height: fit-content;
  }
</style>